import { Modal } from "@components/Modal";
import { FC } from "react";
import { useTranslation } from "@helpers/useTranslation";

type Props = {
  show: boolean;
  messageCopy?: string;
  actionCopy?: string;
  className?: string;
  onOK: () => void;
};

export const OKModal: FC<Props> = ({ show, onOK, messageCopy, actionCopy }) => {
  const { t } = useTranslation("admin");
  messageCopy = messageCopy || t("thisActionCannotBeUndone");
  actionCopy = actionCopy || t("delete");
  if (!show) return null;
  return (
    <Modal show={show} onCancel={onOK} className="z-50" size="sm">
      <h3 className="text-lg font-bold">{t("areYouSure")}</h3>
      <p className="whitespace-pre-wrap py-4">{messageCopy}</p>
      <div className="flex flex-col px-4 py-3">
        <button
          type="button"
          className="inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-base-300 sm:w-auto"
          onClick={() => onOK()}
        >
          {actionCopy}
        </button>
      </div>
    </Modal>
  );
};
